import { getSearchStore } from '../store/Store';

/** Selector function that returns current logicalId for active results */
export function getSearchResultsLogicalId() {
    return getSearchStore().searchResultsLogicalId;
}
